import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import './Auth.css';
import { buildAuthNavigationTarget, resolveReturnTo } from './returnTo';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = resolveReturnTo({ location, fallback: '/home' });

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate(returnTo, { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-layout">
        <div className="auth-visual">
          <span className="tag">Razzberry</span>
          <h1>Welcome back to the club.</h1>
          <p>
            Discover collectibles from verified music artists and manage your account in one place.
          </p>
        </div>

        <form className="auth-box" onSubmit={handleLogin}>
          <h1>Razzberry</h1>
          <h2>Login</h2>
          <p className="auth-subtitle">Welcome back. Jump into the artist marketplace.</p>

        {error && <p className="error">{error}</p>}

        <input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit">Login</button>

        <p className="link" onClick={() => navigate(buildAuthNavigationTarget('/forgot', returnTo), { replace: true })}>
          Forgot Password?
        </p>

          <p className="link" onClick={() => navigate(buildAuthNavigationTarget('/signup', returnTo), { replace: true })}>
            Create Account
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;
